import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LOOKUP from 'constants/lookup';
import { communicatingCrumb } from 'utils/breadcrumbInfo';
import * as types from 'constants/actionTypes';
import { clearFormInput, formInput } from 'actions/FormActions';
import { sendMessage, getSettings, clearMemberList, sendTestMessage, updateTwilioInfo, resetMessageStatus, uploadImage } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import RadioInput from 'screens/components/basic/RadioInput';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CheckInput from 'screens/components/basic/CheckInput';
import Button from "screens/components/basic/Button";
import TextInput from 'screens/components/basic/TextInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

import * as consts from './template';
import MemberItem from './MemberItem';
import SearchFields from './SearchFields';
import EditorToolbar from "./EditorToolbar";
import './style/communicatingPage.css';


const COMPNAME = "communicatingList";

// Undo and redo functions for Custom Toolbar
function undoChange() {
    this.quill.history.undo();
}
function redoChange() {
    this.quill.history.redo();
}

var quillObj;

class CommunicatingPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            status: 'None',
            orderBy: 'DESC',
            sortBy: 'Email',
            loading: false,
            members: [],
            sendBy: "Email",
            selectAll: false,
            htmlText: "",
            text: "",
            subject: "",
            noMemberSelectedDialogOpen: false,
            sendTestSMSDialogOpen: false,
            updateTwilioInfoDialogOpen: false,
            positionOptions: [
                { text: "Left", value: "-webkit-left" },
                { text: "Center", value: "-webkit-center" },
                { text: "Right", value: "-webkit-right" }
            ],
            sizeOptions: [
                { text: "Small", value: "Small" },
                { text: "Medium", value: "Medium" },
                { text: "Large", value: "Large" }
            ],
            positionLogo: "-webkit-left",
            sizeLogo: "Small",
            logo: "",
            logoName: "",
            editorHtml: '',
            messageSent: false,
            imageid: 1
        };

        // this.sort = this.sort.bind(this);
        this.addMemberToList = this.addMemberToList.bind(this);
        this.onChangeSendBy = this.onChangeSendBy.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.getPatients = this.getPatients.bind(this);
        this.replaceData = this.replaceData.bind(this);
        this.setSubject = this.setSubject.bind(this);
        this.toggleNoMemberSelectedDialog = this.toggleNoMemberSelectedDialog.bind(this);
        this.toggleSendTestSMSDialog = this.toggleSendTestSMSDialog.bind(this);
        this.removeMember = this.removeMember.bind(this);
        this.setLogo = this.setLogo.bind(this);
        this.onChangePosition = this.onChangePosition.bind(this);
        this.onChangeSize = this.onChangeSize.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        let branchId = parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'));
        this.props.getSettings(branchId, COMPNAME);
        this.replaceData();
        this.setState({ ...this.state, selectAll: false })
        this.onChangeSendBy(this.state.sendBy);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.messageStatus !== this.props.messageStatus && newProps.messageStatus) {
            this.setState({ editorHtml: "", subject: "", members: [], messageSent: true });
            this.props.clearFormInput(`Subject`);
            this.props.resetMessageStatus();
        }

        if (newProps.imageURL && newProps.imageURL != this.props.imageURL) {
            if (this.state.editorHtml) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        editorHtml: prevState.editorHtml.replace("%r$e#r99#dSADSFAD$#@%#@FSDFG" + prevState.imageid, newProps.imageURL),
                        imageid: prevState.imageid + 1
                    }
                });

            }
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput(`sendBy`);
        this.props.clearMemberList();
    }

    toggleNoMemberSelectedDialog() {
        this.setState({ ...this.state, noMemberSelectedDialogOpen: !this.state.noMemberSelectedDialogOpen });
    }

    toggleSendTestSMSDialog() {
        this.setState({ ...this.state, sendTestSMSDialogOpen: !this.state.sendTestSMSDialogOpen });
    }

    toggleUpdateTwilioInfo = () => {
        this.setState({ ...this.state, updateTwilioInfoDialogOpen: !this.state.updateTwilioInfoDialogOpen });
    }

    openUpdateTwilioInfo = () => {
        if (this.props.updateTwilioAccess) {
            this.setState({ ...this.state, updateTwilioInfoDialogOpen: true });
            this.props.formInput(this.props.ownTwilioSID, 'TwilioSID');
            this.props.formInput(this.props.ownTwilioAuthToken, 'TwilioAuthToken');
            this.props.formInput(this.props.ownTwilioFromNumber, 'TwilioFromPhoneNumber');
        } else {
            alert("Only store owner can update twilio info!");
        }
    }

    sendTestMessage = () => {
        this.toggleSendTestSMSDialog();
        if (this.props.ownTwilioEnabled) {
            let model = {
                BranchId: parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')),
                PhoneNumber: this.props.sendTestSMSPhoneNumber
            }
            this.props.sendTestMessage(model);
        } else {
            alert("Please update twilio credentials and try again!");
            return;
        }
    }

    updateTwilioInfo = () => {
        this.toggleUpdateTwilioInfo();
        let model = {
            BranchId: parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')),
            SID: this.props.updatedTwilioSID,
            AuthToken: this.props.updatedTwilioAuthToken,
            FromPhoneNumber: this.props.updateTwilioFromPhoneNumber
        }

        this.props.updateTwilioInfo(model);
    }

    // Replace the store data in the email body
    replaceData() {
        const p = this.props.store;
        if (this.props.logoURL != "" && this.props.logoURL != null) {
            let logo = this.props.logoURL;
            let logoSplit = this.props.logoURL.split('/');
            let logoName = logoSplit[logoSplit.length - 1]
            var htmlPage = consts.html.replace('@name', p.name)
                .replace('@street', p.street)
                .replace('@city', p.city)
                .replace('@provinceState', p.provinceState)
                .replace('@postalCode', p.postalCode)
                .replace('@phone', p.phone)
                .replace('@site', p.site)
                .replace('<div style="visibility: hidden"></div>', "<div id='imgPreview' style='text-align: " + this.state.positionLogo + "'><img src=" + logo + " id='logo' " + this.getSize(this.state.sizeLogo) + "/></div>");

            this.setState({ ...this.state, htmlText: htmlPage, logo: logo, logoName: logoName });
        } else {
            var htmlPage = consts.html.replace('@name', p.name)
                .replace('@street', p.street)
                .replace('@city', p.city)
                .replace('@provinceState', p.provinceState)
                .replace('@postalCode', p.postalCode)
                .replace('@phone', p.phone)
                .replace('@site', p.site);
            this.setState({ ...this.state, htmlText: htmlPage });
        }


    }

    // get all members in the store
    getPatients = () => {
        let branchId = parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'));
        let model = {
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            firstName: this.props.firstName ? this.props.firstName : "",
            lastName: this.props.lastName ? this.props.lastName : "",
            id: this.props.memberNumberFilter ? this.props.memberNumberFilter : 0,
            phone: this.props.phonenumber ? this.props.phonenumber : "",
            email: this.props.email ? this.props.email : "",
            gender: this.props.gender ? this.props.gender : 0,
            orderBy: this.state.orderBy,
            sortBy: this.state.sendBy == "SMS" ? 'Phone' : 'Email',
            branchId: branchId,
            status: 1,
        };
        this.props.init(model);
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getPatients);
    }

    // when a member is selectDeviceModel, it will be added to the list of member will recieve the email
    addMemberToList(e) {
        let member;
        if (this.state.sendBy == "Email" && e.email.includes("@") && !this.state.members.some(x => x.email == e.email)) {
            member = {
                id: e.id,
                firstName: e.firstName,
                lastName: e.lastName,
                email: e.email,
                phone: e.phone
            }
            this.setState({ ...this.state, members: [...this.state.members, member] })
        } if (this.state.sendBy == "SMS" && e.phone != "" && e.phone != null && !this.state.members.some(x => x.phone == e.phone)) {
            member = {
                id: e.id,
                firstName: e.firstName,
                lastName: e.lastName,
                email: e.email,
                phone: e.phone
            }
            this.setState({ ...this.state, members: [...this.state.members, member] })
        }
    }

    // change the value of the sendby on the state
    onChangeSendBy(e) {
        console.log(e)
        if (this.props.logoURL != "" && this.props.logoURL != null) {
            this.setState({ ...this.state, sendBy: e, text: "", members: [] }, () => { this.getPatients(); this.replaceData(); })
        } else {
            this.setState({ ...this.state, sendBy: e, text: "", logo: "", logoName: "", members: [] }, () => { this.getPatients(); this.replaceData(); })
        }
    }

    //change value of potision
    onChangePosition(e) {
        let htmlPage = this.state.htmlText.replace("id='imgPreview' style='text-align: " + this.state.positionLogo + "'", "id='imgPreview' style='text-align: " + e + "'");
        console.log(e.value);
        this.setState({ ...this.state, positionLogo: e, htmlText: htmlPage })
    }

    onChangeSize(e) {
        let htmlPage = this.state.htmlText.replace("id='logo' " + this.getSize(this.state.sizeLogo), "id='logo' " + this.getSize(e));
        this.setState({ ...this.state, sizeLogo: e, htmlText: htmlPage })
    }

    // add all the members in the list
    selectAll() {
        this.setState({ ...this.state, selectAll: !this.state.selectAll, members: [] })

    }

    // call the method to send the message
    sendMessage() {
        if (this.state.members.length == 0 && this.state.selectAll == false) {
            this.setState({ ...this.state, noMemberSelectedDialogOpen: true });
        } else {
            let SendMessageEmailAndSMS;
            if (this.state.sendBy == "Email") {
                SendMessageEmailAndSMS = {
                    sendBy: this.state.sendBy,
                    members: this.state.members,
                    subject: this.state.subject,
                    text: (this.state.editorHtml).replaceAll("<img", "<img style='padding:0, margin:0'").replaceAll("class=\"ql-align-center\"", "style='text-align:center'")
                        .replaceAll("class=\"ql-align-right\"", "style='text-align:right'").replaceAll("class=\"ql-align-left\"", "style='text-align:left'"),
                    selectAll: this.state.selectAll,
                    logo: this.state.logo
                }
            } else {
                if (this.props.ownTwilioEnabled) {
                    SendMessageEmailAndSMS = {
                        sendBy: this.state.sendBy,
                        members: this.state.members,
                        text: this.state.text,
                        selectAll: this.state.selectAll
                    }
                } else {
                    alert("Please update twilio credentials and try again!");
                    return;
                }
            }
            this.props.sendMessage(SendMessageEmailAndSMS);
        }
    }

    // change the value of the htmlbody in the state
    onChangeText(e) {
        let message = e.target.value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        if (this.state.sendBy == "Email") {
            let htmlPage;
            if (this.state.text == "") {
                htmlPage = this.state.htmlText.replace('@message', "<p>" + message + "</p>");
            } else {
                htmlPage = this.state.htmlText.replace("<p>" + this.state.text + "</p>", message == "" ? "@message" : "<p>" + message + "</p>");
            }

            this.setState({ ...this.state, text: message, htmlText: htmlPage })
        } else {
            this.setState({ ...this.state, text: message })
        }

    }

    // change the value of the suubject in the state
    setSubject(e) {
        let htmlPage;
        if (this.state.subject == "") {
            htmlPage = this.state.htmlText.replace('@subject', "<span>" + e.target.value + "</span>");
        } else {
            htmlPage = this.state.htmlText.replace("<span>" + this.state.subject + "</span>", e.target.value == "" ? "@subject" : "<span>" + e.target.value + "</span>");
        }

        this.setState({ ...this.state, subject: e.target.value, htmlText: htmlPage })
    }

    setLogo(logo) {
        let htmlPage;
        if (this.state.logo == "") {
            htmlPage = this.state.htmlText.replace('<div style="visibility: hidden"></div>', "<div id='imgPreview' style='text-align: " + this.state.positionLogo + "'><img src=" + logo.imagePreviewUrl + " id='logo' " + this.getSize(this.state.sizeLogo) + "/></div>");
        } else {
            htmlPage = this.state.htmlText.replace("<div id='imgPreview' style='text-align: " + this.state.positionLogo + "'><img src=" + this.state.logo + " id='logo' " + this.getSize(this.state.sizeLogo) + "/></div>", "<div id='imgPreview' style='text-align: " + this.state.positionLogo + "'><img src=" + logo.imagePreviewUrl + " id='logo' " + this.getSize(this.state.sizeLogo) + "/></div>");
        }

        this.setState({ ...this.state, logo: logo.imagePreviewUrl, logoName: logo.value.name, htmlText: htmlPage })
    }

    getSize(size) {
        switch (size) {
            case "Small":
                return "width=\"auto\" height=\"100\" style=\"display:block\"";
            case "Medium":
                return "width=\"auto\" height=\"150\" style=\"display:block\"";
            case "Large":
                return "width=\"auto\" height=\"200\" style=\"display:block\"";
            default:
                break;
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getPatients);
    }

    removeMember(e) {
        let membersList;
        if (this.state.sendBy == "Email") {
            membersList = this.state.members.filter(x => x.email != e.email)
        } if (this.state.sendBy == "SMS") {
            membersList = this.state.members.filter(x => x.phone != e.phone)
        }
        this.setState({ ...this.state, members: membersList })
    }

    cleanSearch = () => {
        this.props.clearFormInput(`marketingName`);
        this.props.clearFormInput(`marketingLastName`);
        this.props.clearFormInput(`marketingEmail`);
        this.props.clearFormInput(`marketingPhoneNumber`);
        this.props.clearFormInput(`marketingGenger`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "Id",
                orderBy: "DESC"
            };
        }, () => this.getPatients());
    }

    mapMembers = (patients = []) => {
        return patients.map((item) => {
            let exist = false;
            if (this.state.members.length > 0) {
                exist = this.state.members.some(x => x.id == item.id);
            }

            return {
                Id: item.id,
                Key: item.id,
                FirstName:
                    <span className="list-item list-item-name">
                        {item.firstName + " " + item.lastName}
                    </span>,
                LastName: item.lastName,
                Status:
                    item.status !== "Active" ? (
                        <p className="statusIconRed m-0">{item.status}</p>
                    ) : (
                        <p className="statusIconGreen m-0">{item.status}</p>
                    ),
                Email: item.email,
                SMS: item.phone,
                Icons: exist ? ("") : (
                    <Button
                        type="AddMember"
                        mini={true}
                        onTouchTap={() => this.addMemberToList(item)}
                    />
                )
            };
        });
    };

    handleChange(html) {
        this.setState({ editorHtml: html });
    }

    imageHandler = () => {
        const input = document.createElement('input');

        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        let reader = new FileReader();
        reader.onloadend = () => {
            this.props.uploadImage({ Image: reader.result });
        };

        input.onchange = async () => {

            var file = input.files[0];
            let extension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();
            console.log(extension);
            if (file.size < 4000000 && (extension == 'jpg' || extension == 'png' || extension == 'jpeg')) {
                reader.readAsDataURL(file);
                const range = quillObj.getEditorSelection();
                quillObj.getEditor().insertEmbed(range.index, 'image', "%r$e#r99#dSADSFAD$#@%#@FSDFG" + this.state.imageid);
            }
            else {
                alert("Please upload a jpg or png file and it must be less then 4MB in size");
            }

        };
    }

    render() {
        const sendTo = LOOKUP.menu.admin.communicating.sendBy;
        const p = this.props;
        const s = this.state;

        const modules = {
            toolbar: {
                container: "#toolbar",
                handlers: {
                    undo: undoChange,
                    redo: redoChange,
                    image: this.imageHandler
                }
            },
            history: {
                delay: 500,
                maxStack: 100,
                userOnly: true
            }
        };

        // Formats objects for setting up the Quill editor
        const formats = [
            "header",
            "size",
            "bold",
            "italic",
            "underline",
            "align",
            "strike",
            "script",
            "blockquote",
            "background",
            "list",
            "bullet",
            "indent",
            "link",
            "image",
            "color",
            "code-block"
        ];

        return (
            <Grid headerContent={communicatingCrumb}>
                {
                    this.state.messageSent ? (
                        <div style={{ backgroundColor: 'greenyellow', padding: 10, textAlign: 'center' }}>
                            <h4>Communication sent succesfully</h4>
                        </div>
                    ) : null
                }
                <br />
                <div className="col-4-padding">
                    <div className="row">
                        <div className="col-lg-4 d-flex align-items-center">
                            <h5 className="font-weight-light mt-0 ml-2"> Send by: </h5>
                        </div>
                        <div className="col-lg-4 pt-1">
                            <RadioInput groupName={"sendBy"}
                                options={sendTo}
                                className="inline-radio-btns rdBtnLabels"
                                defaultValue={this.state.sendBy}
                                onChangeCallback={this.onChangeSendBy}
                            />
                        </div>
                        <div className="col-lg-4">
                            <CheckInput name="selectAll" text="Send to All Members" className="checkBoxLabels" onCheck={this.selectAll} />
                        </div>
                        <div className="col-lg-12">
                            <p>
                                Note: if customers are having the email/sms checkbox unchecked in the member edit page, we won't send emails/sms to them.
                            </p>
                        </div>
                        {
                            this.state.sendBy == "SMS" ?
                                <div className="col-lg-5 text-right smstwiliobtn ml-5">
                                    <Button
                                        className="btnNewBrandPOS mt-2"
                                        type="RaisedButton"
                                        label={this.props.ownTwilioEnabled ? "Update Twilio Credentials" : "Add Twilio Credentials"}
                                        onTouchTap={this.openUpdateTwilioInfo}
                                    />
                                    <br />
                                    <h4>
                                        <a href="/support-document#twilio-setup" target="_blank">
                                            How to set up twilio account
                                        </a>
                                    </h4>
                                    <Button
                                        className="btnNewBrandPOS mt-1"
                                        type="RaisedButton"
                                        label={"Send Test Message"}
                                        onTouchTap={this.toggleSendTestSMSDialog}
                                    />
                                </div>
                                : ""
                            }
                    </div>
                </div>
                <SearchFields pageName={"marketing"} search={this.getPatients} cleanSearch={this.cleanSearch} />
                <div className="row">
                    <div id="patient-list-table" className="col-md-6 col-4-padding">
                        <CardSimple >
                            <div className="form-group">
                                <GenericTable
                                    className="table_center tableHeaderwhiteColorFont"
                                    tableBodyClassName="patients-table"
                                    multiSelectable={false}
                                    enableSelectAll={false}
                                    selectable={false}
                                    columns={
                                        this.state.sendBy == "" ? LOOKUP.menu.admin.communicating.columns :
                                            this.state.sendBy == "Email" ? LOOKUP.menu.admin.communicating.columnsEmail :
                                                LOOKUP.menu.admin.communicating.columnsSMS

                                    }
                                    rows={this.mapMembers(p.patients)}
                                    orderBy={this.state.orderBy}
                                    sortBy={this.state.sortBy}
                                    sort={this.sort}
                                    stripedRows={true}
                                />
                                <Pagination
                                    length={p.patientListLength || 0}
                                    itemsPerPage={s.itemsPerPage}
                                    activePage={s.activePage}
                                    onPageChange={this.changePage}
                                    maxButtons={4} />
                            </div>
                        </CardSimple>
                    </div>
                    <div className="col-md-6">
                        <CardSimple>
                            <div>
                                {
                                    this.state.sendBy == "" ? (
                                        <h4 style={{ padding: 20, textAlign: 'center' }}>Select if you want to send a message by <b>Email</b> or <b>SMS</b></h4>
                                    ) : this.state.sendBy == "Email" ? (
                                        <div className='paddingForMobileDevices'>
                                            <h4 className='pt-2'>Send Email</h4>
                                            <div style={{ display: 'flow-root' }}>
                                                <span>To:</span>
                                                <div style={{ scrollBehavior: 'smooth' }} >
                                                    {
                                                        this.state.selectAll ? (
                                                            <h4>All members have been selected</h4>
                                                        ) : (
                                                            this.state.members.map((item) => {
                                                                return <MemberItem sendBy={this.state.sendBy} member={item} onTouchTap={this.removeMember} style={{ borderBlockStyle: 'solid' }} />
                                                            })
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className="mt-2">
                                                <span>Subject:&nbsp;&nbsp;
                                                    <TextInput
                                                        name={`Subject`}
                                                        className="search-field-subject"
                                                        onInput={this.setSubject}
                                                    />
                                                </span>
                                            </div>

                                            <div className="text-editor mt-2">
                                                <EditorToolbar />
                                                <ReactQuill
                                                    ref={(el) => {
                                                        quillObj = el;
                                                    }}
                                                    theme="snow"
                                                    value={this.state.editorHtml}
                                                    onChange={this.handleChange}
                                                    placeholder={"Place message content here..."}
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </div>

                                        </div>

                                    ) :
                                        (
                                            <div>
                                                <h4>Send SMS</h4>
                                                <span>To:</span>
                                                <div style={{ scrollBehavior: 'smooth' }}>
                                                    {
                                                        this.state.selectAll ? (
                                                            <h4>All members have been selected</h4>
                                                        ) : (
                                                            this.state.members.map((item) => {
                                                                return <MemberItem sendBy={this.state.sendBy} member={item} onTouchTap={this.removeMember} />
                                                            })
                                                        )
                                                    }
                                                </div>
                                                <textarea style={{ width: "100%", height: 100, whiteSpace: 'pre-wrap', border: "1px solid #7A60E5", boxSizing: 'border-box' }} onInput={this.onChangeText} />
                                            </div>
                                        )
                                }
                            </div>
                        </CardSimple>
                        {
                            this.state.sendBy == "" ? (
                                <div></div>

                            ) :
                                (
                                    <div className="col-lg-10 form-label" >
                                        <Button
                                            className="btnNewBrandPOS mt-2"
                                            type="RaisedButton"
                                            label={"Send"}
                                            onTouchTap={this.sendMessage}
                                        />
                                    </div>
                                )

                        }

                    </div>
                </div>
                <DialogInput
                    title={<DialogHeader text="No members selected" />}
                    modal={true}
                    open={this.state.noMemberSelectedDialogOpen}
                    autoScrollBodyContent={false}>
                    Please, select at least one member to send a {this.state.sendBy}
                    <div className="col-lg-12" style={{ textAlign: 'center' }}>
                        <br />
                        <Button className="rounded-btn" label="Ok" style={{ width: "50%" }} primary onTouchTap={this.toggleNoMemberSelectedDialog} />
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeader text="Please input phone number for test" />}
                    modal={true}
                    open={this.state.sendTestSMSDialogOpen}
                    autoScrollBodyContent={false}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.toggleSendTestSMSDialog()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label="Send"
                            primary={true}
                            onTouchTap={() => this.sendTestMessage()} />]}>
                    <div>
                        <TextInput
                            name={`SendTestSMSPhoneNumber`}
                            className="search-field"
                            label="Phone Number"
                            floatingLabelText="Phone Number"
                            hintText="Phone Number"
                            style={{ with: "10%", paddingLeft: 10 }}
                        />
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeader text="Update Twilio Credentials" />}
                    modal={true}
                    open={this.state.updateTwilioInfoDialogOpen}
                    autoScrollBodyContent={false}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.toggleUpdateTwilioInfo()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label="Confirm"
                            primary={true}
                            onTouchTap={() => this.updateTwilioInfo()} />]}>
                    <div>
                        <TextInput
                            name={`TwilioSID`}
                            className="search-field"
                            label="SID"
                            floatingLabelText="SID"
                            hintText="SID"
                            style={{ with: "10%", paddingLeft: 10 }}
                        />
                        <TextInput
                            name={`TwilioAuthToken`}
                            className="search-field"
                            label="AuthToken"
                            floatingLabelText="AuthToken"
                            hintText="AuthToken"
                            style={{ with: "10%", paddingLeft: 10 }}
                        />
                        <TextInput
                            name={`TwilioFromPhoneNumber`}
                            className="search-field"
                            label="From Phone Number"
                            floatingLabelText="From Phone Number"
                            hintText="From Phone Number"
                            style={{ with: "10%", paddingLeft: 10 }}
                        />
                    </div>
                </DialogInput>
            </Grid>

        );
    }

}

function mapStatetoProps(state) {
    return {
        patients: state.entity.patientList,
        patientListLength: state.entity.patientListLength,
        store: state.common.store,
        logoURL: state.common.applicationSettings.logoUrl,
        messageStatus: state.entity.messageStatus,
        firstName: state.form.marketingName,
        lastName: state.form.marketingLastName,
        email: state.form.marketingEmail,
        phonenumber: state.form.marketingPhoneNumber,
        gender: state.form.marketingGenger,
        ownTwilioEnabled: state.common.applicationSettings.ownTwilioEnabled,
        ownTwilioSID: state.common.applicationSettings.ownTwilioSID,
        ownTwilioAuthToken: state.common.applicationSettings.ownTwilioAuthToken,
        ownTwilioFromNumber: state.common.applicationSettings.ownTwilioFromNumber,
        sendTestSMSPhoneNumber: state.form[`SendTestSMSPhoneNumber`],
        updatedTwilioSID: state.form[`TwilioSID`],
        updatedTwilioAuthToken: state.form[`TwilioAuthToken`],
        updateTwilioFromPhoneNumber: state.form[`TwilioFromPhoneNumber`],
        updateTwilioAccess: state.common.authenticatedUser ? state.common.authenticatedUser.roles.includes("StoreOwner") ? true : false : false,
        imageURL: state.entity.imageURL || ""
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (model) => dispatch({ type: types.PATIENT_LIST_LOAD, model }),
        getSettings: (branchId, compName) => dispatch(getSettings(branchId, compName)),
        sendMessage: (model) => dispatch(sendMessage(model)),
        sendTestMessage: (model) => dispatch(sendTestMessage(model)),
        updateTwilioInfo: (model) => dispatch(updateTwilioInfo(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearMemberList: () => dispatch(clearMemberList()),
        resetMessageStatus: () => dispatch(resetMessageStatus()),
        uploadImage: (model) => dispatch(uploadImage(model))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(CommunicatingPage);
